export default {
  title: '商品一覧',
  addProduct: '商品追加',
  editProduct: '商品編集',
  productName: '商品名',
  productNo: '商品番号',
  productCategory: '商品カテゴリ',
  productLang: '商品言語',
  id: 'ID',
  productInfo: '商品情報',
  retailPrice: '小売価格',
  spec: '仕様',
  singleSpec: '単一仕様',
  multiSpec: '複数仕様',
  detail: '詳細',
  multiSpecModal: '複数仕様設定',
  specNo: '仕様番号',
  specInfo: '仕様情報',
  price: '価格',
  select: '選択',
  selected: '選択済み',
  selectedProducts: '選択済み商品',
  unselectedProducts: '未選択商品',
};
